// extracted by css-extract-rspack-plugin
export default {"SameSiteAlert":"xPoYT"};